export class InventoryTransferLine {
    LineNum: number;
    ItemCode: string;
    ItemName: string;
    Quantity: number;
    FromWhsCod: string;
    WhsCode: string;
}
